import * as React from "react";
import { Box, Grid, Link, MenuList, MenuItem } from "@material-ui/core";
import cx from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { SvgIcon } from "../../../../components";

interface IProps {
  profileList: {
    isShown: boolean;
    label: string;
    svgType?: string;
    link?: string;
    onClick?: () => void;
    "data-testid"?: string ;
  }[];
  excludeBoxStyles?: boolean;
}

export const MUIProfileMenu = ({ profileList, excludeBoxStyles }: IProps) => {
  const classes = useStyles();

  return (
      <Box className={cx({[classes.profileMenu]: !excludeBoxStyles})}>
        <MenuList>
          {profileList
            .filter((item) => item.isShown)
            .map((item) => (
              <Link
                data-testid={item["data-testid"]}
                href={item.link}
                target={(window as any)._isMobileApp ? '_self' : "_blank"}
                key={`profile-${Math.random()}`}
                onClick={item.onClick}
              >
                <MenuItem>
                  <Grid container spacing={1} wrap="nowrap" alignItems="center">
                    {
                      item.svgType &&
                      <Grid item>
                        <SvgIcon type={item.svgType} />
                      </Grid>
                    }
                    <Grid item>{item.label}</Grid>
                  </Grid>
                </MenuItem>
              </Link>
            ))}
        </MenuList>
      </Box>
  );
};


const useStyles =  makeStyles((theme) => ({
  online: {
    "&:after": { backgroundColor: theme.palette.success.light },
  },
  offline: {
    "&:after": { backgroundColor: theme.palette.error.light },
  },
  profileMenu: {
    backgroundColor: theme.palette.common.white,
    //@ts-ignore
    border: theme.palette.border,
    borderWidth: 1,
    borderStyle: 'solid',
    color: theme.palette.common.white,
    fontSize: "13px",
    lineHeight: "16px",
    fontWeight: 400,
    zIndex: 1600,
    textAlign: "left",
    whiteSpace: "nowrap",
    cursor: "pointer",
    borderRadius: theme.shape.borderRadius,
  },
}))
